<script setup lang="ts">
import { tv, type VariantProps } from 'tailwind-variants/lite'
import { computed, type Component } from 'vue'

const style = tv({
  base: 'lui-icon',
  variants: {
    size: {
      xs: 'lui-icon--size-xs',
      sm: 'lui-icon--size-sm',
      md: 'lui-icon--size-md',
      lg: 'lui-icon--size-lg',
      xl: 'lui-icon--size-xl',
      '2xl': 'lui-icon--size-2xl',
      full: 'lui-icon--size-full',
    },
  },
})

export interface IconProps {
  is?: Component
  size?: VariantProps<typeof style>['size']
}

const props = defineProps<IconProps>()

const classes = computed(() =>
  style({
    size: props.size,
  }),
)
</script>

<!-- heroicons don't accept props/attributes, so we wrap them in a span that acts as the image -->
<template>
  <span role="img" aria-hidden="true" :class="classes">
    <component :is="props.is" />
  </span>
</template>

<style>
@reference "../../css/tailwind.css";

@layer components {
  .lui-icon {
    @apply inline-block shrink-0 align-middle;
  }

  .lui-icon--size-full {
    @apply size-full;
  }
}
</style>
